export const basePagesMutations = {
  SET_ITEMS(state, payload) {
    state.items = payload;
  },

  ADD_ITEM(state, payload) {
    state.items.unshift(payload);
  },

  UPDATE_ITEM(state, payload) {
    state.items = state.items.map(item => (item.id === payload.id ? payload : item));
  },

  REMOVE_ITEM(state, payload) {
    state.items = state.items.filter(item => item.id !== payload.id);
  },

  SET_META_TOTAL(state, payload) {
    state.meta.total = payload;
  },

  INCREASE_META_TOTAL(state) {
    state.meta.total = state.meta.total + 1;
  },

  DECREASE_META_TOTAL(state) {
    if (state.meta.total > 0) {
      state.meta.total = state.meta.total - 1;
    }
  },
};
